import React from 'react';
import styles from './Leaders.module.css';
import leader1 from "../../images/leader/1.png";
import leader2 from "../../images/leader/5.png";
import leader3 from "../../images/leader/3.png";
import leader4 from "../../images/leader/4.png";
// import leader2 from 'https://imgs.search.brave.com/avQbo97PWopkX9lPCY0pOY_ZFnfld80sUsgJl7uhvQA/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9tZWRp/YS5pc3RvY2twaG90/by5jb20vaWQvNTE1/OTMwOTkzL3ZlY3Rv/ci9tYW4taGVhZC1h/bmQtc2hvdWxkZXJz/LXNpbGhvdWV0dGUt/d2l0aC1leGNhbG1h/dGlvbi1tYXJrLXZl/Y3Rvci5qcGc_cz02/MTJ4NjEyJnc9MCZr/PTIwJmM9ejVTNkxE/azNDRE9veDVqU00w/bVNDSXF4anNseEhV/WjN0VmlwS2xDTFdW/dz0';
// import leader3 from 'https://imgs.search.brave.com/avQbo97PWopkX9lPCY0pOY_ZFnfld80sUsgJl7uhvQA/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9tZWRp/YS5pc3RvY2twaG90/by5jb20vaWQvNTE1/OTMwOTkzL3ZlY3Rv/ci9tYW4taGVhZC1h/bmQtc2hvdWxkZXJz/LXNpbGhvdWV0dGUt/d2l0aC1leGNhbG1h/dGlvbi1tYXJrLXZl/Y3Rvci5qcGc_cz02/MTJ4NjEyJnc9MCZr/PTIwJmM9ejVTNkxE/azNDRE9veDVqU00w/bVNDSXF4anNseEhV/WjN0VmlwS2xDTFdW/dz0';


const leaders = [
  { name: 'Bobby Bonser',role: 'Director of Sales', img: leader3 , text:"Bridging decades of automotive dealership expertise with cutting-edge AI innovation, Bobby leads the charge in delivering transformative tech solutions to the automotive space and beyond." },
  { name: 'Sneha Seth',role: 'Founder and CMO', img: leader1, text:"CMO with a sharp eye for emerging tech trends, leading go-to-market strategy and brand storytelling for AI products transforming automotive and other key sectors."},
  { name: 'Dhananjay Kumar',role: 'Director', img: leader2 ,text:"Tech innovator specializing in scalable solutions, with a passion for driving digital transformation across industries."},
  { name: 'Vishal',role: 'Solution Architect', img: leader4 ,text:"Expert in designing end-to-end AI solutions that align tech innovation with real-world impact—driving digital transformation in Automotive, Fintech, Retail and beyond."},
];

const features = [
  { icon: '📌', text: 'Provaantech is a dynamic software engineering company delivering tailored IT solutions.' },
  { icon: '🌐', text: 'We serve industries like aerospace, finance, automotive, farming, media & more.' },
  { icon: '🧠', text: 'Our expert team solves complex challenges with deep tech knowledge and experience.' },
  { icon: '🚀', text: 'We harness AI, IoT, Blockchain, Smart Home tech, Data Science, Azure & AWS.' },
  { icon: '🔧', text: 'From hardware integration to secure digital platforms, we build future-ready systems.' },
  { icon: '🤝', text: 'Provaantech is your trusted partner in innovation, growth, and digital transformation.' },
];

const Leaders = () => {
  return (
    <div className={styles.container}>
      <h2 className={styles.heading}>Meet our leaders</h2>
      <div className={styles.leaderGrid}>
        {leaders.map((leader, index) => (
          <div className={styles.leaderCard} key={index}>
            <div className={styles.shape}></div>
            <img src={leader.img} alt={leader.name} className={styles.image} />
              <div className={styles.shape2}></div>
            <p className={styles.name}>{leader.name}</p>
             <p className={styles.role}>{leader.role}</p>
              <p className={styles.text}>{leader.text}</p>
          </div>
        ))}
      </div>

      <div className={styles.features}>
        {features.map((feature, idx) => (
          <div className={styles.featureBox} key={idx}>
            {/* <span className={styles.icon}>{feature.icon}</span> */}
            <span>{feature.text}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Leaders;
